import http from "../http-common";
/* eslint-disable */
class PsikologisHasilService {
  getList(page, itemPerPage, keyword, alatTestId) {
    return http.get(
      "/psikologis-hasil/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&alat_test_id=" +
        alatTestId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  getListJawaban(page, itemPerPage, hasilId) {
    return http.get(
      "/psikologis-hasil/jawaban/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&psikologis_hasil_id=" +
        hasilId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  downloadLoyalitas(keyword) {
    return http.get("/report/loyalitas/download?keyword=" + keyword, {
      headers: {
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
      responseType: "blob",
    });
  }

  getListLaporan(page, itemPerPage) {
    return http.get(
      "/psikologis-hasil/laporan/list?page=" +
        page +
        "&itemsPerPage=" +
        itemPerPage,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }
}

export default new PsikologisHasilService();
